import { tracking } from '@iwoca/frontend-tracking-library';

import { TEnabledOptions } from './useEnabledTerms';
import { useOnce } from '../../hooks/useOnce';

const OPTIONS_TO_TRACKING = {
  THREE_MONTHS: 'pay_in_3',
  TWELVE_MONTHS: 'pay_in_12',
  PAY_NOW: 'pay_now',
} as const;

export function useTrackLandingPageView({
  payLinkType,
  visibleOptions,
}: {
  payLinkType: 'generic' | 'custom' | 'spending_limit' | 'package';
  visibleOptions: TEnabledOptions;
}) {
  return useOnce({
    conditionFn: visibleOptions.length > 0,
    fn: () =>
      tracking.ampli.payLinkLandingPageViewed({
        pay_link_type: payLinkType,
        visible_payment_options: visibleOptions.map(
          (option) => OPTIONS_TO_TRACKING[option],
        ),
      }),
  });
}
